var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.modalId,
        size: "m",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        "no-fade": "",
        "no-stacking": "",
        centered: ""
      },
      scopedSlots: _vm._u(
        [
          {
            key: "modal-header",
            fn: function() {
              return [
                _c(
                  "b-row",
                  {
                    staticClass: "w-100",
                    attrs: { "align-v": "center", "no-gutters": "" }
                  },
                  [
                    _c("b-col", [
                      _c("h2", { staticClass: "modal-title" }, [
                        _c("i", {
                          staticClass:
                            "fas fa-exclamation-triangle colorOrange mr-1"
                        }),
                        _vm._v(
                          " " + _vm._s(_vm.$t("xLicenseRestriction")) + " "
                        )
                      ])
                    ]),
                    _c(
                      "b-col",
                      { staticClass: "float-right", attrs: { cols: "auto" } },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn-icon-button--gray",
                            attrs: {
                              variant: "icon-button",
                              "data-test-hook":
                                "x-button-fuel-monitors-not-allowed-button"
                            },
                            on: {
                              click: function($event) {
                                return _vm.$emit("onClose")
                              }
                            }
                          },
                          [_c("i", { staticClass: "fas fa-times" })]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "modal-footer",
            fn: function() {
              return [_vm._t("default")]
            },
            proxy: true
          }
        ],
        null,
        true
      )
    },
    [
      _c("b-row", { staticClass: "modal-body" }, [
        _vm._v(" " + _vm._s(_vm.$t("xFuelMonitorsNotAllowedForRegion")) + " ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }